<h1 *ngIf="!mobile"
    mat-dialog-title>
    {{ 'default.printPdf' | blah }}
</h1>
<div>
    <div class="form-container">
        <div class="checkbox-container">
            <div>{{ 'default.printPdfComponent.select' + targetType + 'Entities' | blah }}</div>
            <ng-container *ngFor="let entity of targetEntities; let i = index">
                <mat-checkbox id="print-pdf-{{entity.entity}}-checkbox"
                    name="{{entity.entity}}"
                    [(ngModel)]="entity.checked">
                    {{ entity.blah | blah }}
                </mat-checkbox>
            </ng-container>
        </div>
    </div>
</div>
<mat-dialog-actions align="end">
    <button id="print-pdf-cancel-button"
        mat-stroked-button
        mat-dialog-close>
        {{ 'default.cancel' | blah | uppercase }}
    </button>
    <button id="print-pdf-print-button"
        mat-stroked-button
        color="accent"
        (click)="submit()">
        {{ 'default.print' | blah | uppercase }}
    </button>
</mat-dialog-actions>